var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabletIcon = function SvgTabletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#151414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.767 14.47a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h8ZM8 6.5c-.28 0-.5.22-.5.5v10c0 .28.22.5.5.5h8c.28 0 .5-.22.5-.5V7c0-.28-.22-.5-.5-.5H8Z"
  }))));
};
export default SvgTabletIcon;